import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputDate_inputWrapper: {
			display: 'flex',
			flexDirection: 'column',
		}
	});
});

export default useStyles;
